import i18n from '../i18n';

const options = [
  {
    name: 'English',
    locale: 'en',
    languages: ['en', 'en-AU', 'en-GB', 'en-US'],
  },
  {
    name: '简体中文',
    locale: 'zh_hans',
    languages: ['zh_hans', 'zh-CN', 'zh'],
  },
  {
    name: '繁體中文',
    locale: 'zh_hant',
    languages: ['zh_hant', 'zh-TW', 'zh-HK'],
  },
  { name: '日本語', locale: 'ja', languages: ['ja', 'ja-JP'] },
];

const init = () => {
  const selectedLanguage = getSelectedLanguageInStorage();
  let currentLanguage = null;

  if (selectedLanguage) {
    i18n.locale = selectedLanguage.locale;
    currentLanguage = selectedLanguage;
  } else {
    const browserLanguage = navigator.language;
    const matchedLanguage = options.find((i) =>
      i.languages.includes(browserLanguage)
    );

    if (matchedLanguage) {
      i18n.locale = matchedLanguage.locale;
      currentLanguage = matchedLanguage;
    }
  }

  window.changeLocale(i18n.locale);

  return currentLanguage;
};

const getSelectedLanguageInStorage = () => {
  const lang = localStorage.getItem('lang');

  if (lang) {
    return JSON.parse(lang);
  } else {
    return null;
  }
};

export default {
  options,
  init,
  getSelectedLanguageInStorage,
};
